<button
  type="button"
  role="switch"
  class="sz-toggle"
  [class.sz-toggle--on]="value()"
  [class.sz-toggle--disabled]="disabledState()"
  [disabled]="disabledState()"
  [attr.aria-checked]="value()"
  [attr.aria-label]="ariaLabel()"
  (click)="toggle()">
  <span class="sz-toggle__thumb" aria-hidden="true"></span>
</button>
